import { FC, useCallback, useEffect, useState } from 'react'

import { Container } from 'components/container'
import { useAppContext } from 'context/app-context'
import { Share } from '../share'
import { StyledFooter, Title } from './styled'

export const Footer: FC = () => {
  const { setFooterVisible } = useAppContext()
  const [footerRef, setFooterRef] = useState<HTMLElement | null>(null)
  const refCallback = useCallback((node: HTMLElement) => {
    setFooterRef(node)
  }, [])

  useEffect(() => {
    let observer: IntersectionObserver

    if (footerRef) {
      observer = new IntersectionObserver(
        ([entry]) => {
          setFooterVisible(entry.isIntersecting)
        },
        { rootMargin: '0px 0px -20% 0px' }
      )
      observer.observe(footerRef)
    }

    return () => {
      observer?.disconnect()
    }
  }, [footerRef])

  return (
    <Container>
      <StyledFooter ref={refCallback}>

        <Title>Над проектом работали</Title>
        <dl>
          <div>
            <dt>Ведущий</dt>
            <dd>Игорь Севрюгин</dd>
          </div>
          <div>
            <dt>Режиссерка</dt>
            <dd>Диана Шляпникова</dd>
          </div>
          <div>
            <dt>Редактор</dt>
            <dd>Андрей Цыганов</dd>
          </div>
          <div>
            <dt>Оператор</dt>
            <dd>Саша П</dd>
          </div>
          <div>
            <dt>Монтаж</dt>
            <dd>А. К.</dd>
          </div>
          <div>
            <dt>Монтаж</dt>
            <dd>Диана Шляпникова</dd>
          </div>
          <div>
            <dt>Арт-директор</dt>
            <dd>Ксандра</dd>
          </div>
          <div>
            <dt>Моушен-дизайн</dt>
            <dd>Владислав Ант</dd>
          </div>
          <div>
            <dt>Цветокоррекция</dt>
            <dd>Криштоф Майкснер</dd>
          </div>
          <div>
            <dt>Звук</dt>
            <dd>Александр Макрев</dd>
          </div>
          <div>
            <dt>Digital-редакторка</dt>
            <dd>Кристина Закурдаева</dd>
          </div>
          <div>
            <dt>Разработка сайта</dt>
            <dd>Pangea Digital team</dd>
          </div>
        </dl>

        <Title>Присоединяйтесь</Title>
        <Share />
      </StyledFooter>
    </Container>
  )
}
